import React from "react"
import Cabecalho from "../Cabecalho"
import { RankingClientes } from "./components/RankingClientes"

export function PosicaoClientes() {
    return (
        <>
            <Cabecalho pagina="Posição de Clientes" />
            <RankingClientes />
        </>
    )
}
